export default "__VITE_ASSET__Bpv_Ho2y__"